import { HugeiconsIcon } from "@hugeicons/react";
import type { FC } from "react";
import { cn } from "../../utils";
import { type GameRtpTrend, TREND_ICONS } from "./computeRtpTrend";
import computeVariantStyle, {
  type GameRtpListVariant,
} from "./computeVariantStyle";

type Props = {
  percentage: string;
  variant: GameRtpListVariant;
  trend?: GameRtpTrend;
};

const GameRtpListBadge: FC<Props> = ({
  percentage,
  variant,
  trend = "neutral",
}) => {
  const { bg } = computeVariantStyle(variant);
  const trendIcon = TREND_ICONS[trend];

  return (
    <span
      data-slot="game-rtp-list-badge"
      data-trend={trend}
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-md px-2.5 py-1 font-semibold text-sm text-white",
        bg,
      )}
    >
      {percentage}
      {trendIcon && <HugeiconsIcon icon={trendIcon} className="size-3.5" />}
    </span>
  );
};

export default GameRtpListBadge;
